import { render, staticRenderFns } from "./E404.vue?vue&type=template&id=2587d1f1&"
import script from "./E404.vue?vue&type=script&lang=js&"
export * from "./E404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports